<template>
  <clip-loader v-show="loading" />
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    };
  },
  mounted: function () {
    if (!this.$route.query.grandidsession) {
      axios.get("/api/internal/auth/siths").then((response) => {
        window.location = response.data.redirectUrl;
      });
    } else {
      // Something when wrong
      this.$router.push({ name: "Auth" });
    }
  },
};
</script>
